import { ButtonData, DynamicContentType } from '@bm-js/atlascloud-shared'
import { useMemo } from 'react'
import { CLink, LinkComponentType } from './CLink'
import { CustomerButton } from './CustomerButton'

const flexAlignments = {
  left: 'justify-start',
  center: 'justify-center',
  right: 'justify-end',
  'center-mobile': '@2xl/grid:justify-start justify-center',
}

type Props = {
  LinkComponent: LinkComponentType
  content: DynamicContentType<ButtonData>
}

export const ButtonContent = ({ content, LinkComponent }: Props) => {
  const { buttonText, alignment, link, ...buttonProps } = content.data

  const flexClass = useMemo(() => {
    return flexAlignments[alignment || 'left']
  }, [content.data.alignment])

  return (
    <CLink
      LinkComponent={LinkComponent}
      href={link}
      className={`flex clean ${flexClass}`}
    >
      <CustomerButton {...buttonProps}>
        {content.data.buttonText}
      </CustomerButton>
    </CLink>
  )
}
